var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row",attrs:{"if":_vm.isLoading}},[_c('canvas',{ref:"canvas",staticStyle:{"position":"relative"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }